<script lang="ts">
  import { getContext } from 'svelte'
  import type { FlashState } from '#app/lib/components/flash.svelte'
  import { onChange } from '#app/lib/svelte/svelte'
  import { arrayIncludes, objectKeys } from '#app/lib/utils'
  import type { Facets, FacetsSelectedValues } from '#app/types/entity'
  import SelectDropdown from '#components/select_dropdown.svelte'
  import { entityProperties, getSubEntitiesFacets, getFacetsEntitiesBasicInfo, type FacetsSelectors } from '#entities/components/lib/sub_entities_browser_helpers'
  import type { SerializedEntity } from '#entities/lib/entities'
  import { i18n } from '#user/lib/i18n'

  let {
    subEntities,
    facets = $bindable(),
    facetsSelectors = $bindable(),
    facetsSelectedValues = $bindable(),
    flash = $bindable(),
  }: {
    subEntities: SerializedEntity[]
    facets: Facets
    facetsSelectors: FacetsSelectors
    facetsSelectedValues: FacetsSelectedValues
    flash?: FlashState
  } = $props()

  const layoutContext = getContext('layout-context')
  const facetsObj = $derived(getSubEntitiesFacets(subEntities, layoutContext))

  const urisCount = $derived(facetsObj.valuesUris.length)
  const loadingMessage = $derived(i18n('loading_facets_may_take_a_while', { smart_count: urisCount }))

  let waitingForOptions: Promise<void> = $state()
  $effect(() => {
    onChange(facetsObj, () => {
      ;({ facets, facetsSelectedValues } = facetsObj)
      waitingForOptions = getFacetsEntitiesBasicInfo(facetsObj)
        .then(res => ({ facets, facetsSelectedValues, facetsSelectors } = res))
        .catch(err => flash = err)
    })
  })
</script>

{#if facets}
  {#each objectKeys(facets) as property (property)}
    <SelectDropdown
      bind:value={facetsSelectedValues[property]}
      options={facetsSelectors?.[property].options}
      resetValue="all"
      {waitingForOptions}
      {loadingMessage}
      buttonLabel={i18n(property)}
      withImage={arrayIncludes(entityProperties, property)}
    />
  {/each}
{/if}
